import React from 'react';
import { useTranslation } from 'react-i18next';

import { AppContext } from '../AppContext';
import * as C from '../components';

export const SelectStore = ({
  depart,
  selectedStore,
  setSelectedStore,
}: {
  depart: string;
  selectedStore: string;
  setSelectedStore: (value: string) => void;
}) => {
  const appCtx = React.useContext(AppContext);
  const { t, i18n } = useTranslation();

  const [store, setStore] = React.useState<any[]>([]);

  React.useEffect(() => {
    if (appCtx.token && depart !== '') {
      appCtx
        .fetchApi('get', `/api/v2/stores?depart=${depart}`)
        .then((result) => {
          if (result) {
            setStore(
              result.data.map((item: any) => ({
                title: item.name,
                value: item.id,
              })),
            );
          }
        });
    }
  }, [appCtx.token, depart]);

  return (
    <C.Select
      options={store}
      value={selectedStore}
      onValueChange={setSelectedStore}
    />
  );
};
